import { useMemo } from 'react'
import './AnalyticsStitchScreen.css'

function normalizeStitchHtml(rawHtml) {
  if (!rawHtml || typeof window === 'undefined') {
    return { styles: '', content: '' }
  }

  const parser = new DOMParser()
  const doc = parser.parseFromString(rawHtml, 'text/html')

  doc.querySelectorAll('script').forEach((node) => node.remove())
  doc.querySelectorAll('aside, header').forEach((node) => node.remove())

  const styles = Array.from(doc.querySelectorAll('style'))
    .map((node) => node.textContent || '')
    .join('\n')

  const mainNode = doc.querySelector('main')
  const content = mainNode ? mainNode.innerHTML : (doc.body?.innerHTML || '')

  return { styles, content }
}

export default function AnalyticsStitchScreen({ html, title }) {
  const parsed = useMemo(() => normalizeStitchHtml(html), [html])

  return (
    <>
      {parsed.styles ? <style>{parsed.styles}</style> : null}
      <div
        className="analytics-stitch-content"
        aria-label={title}
        dangerouslySetInnerHTML={{ __html: parsed.content }}
      />
    </>
  )
}
